import {
  getNumberOfPages,
  getRecordSetSize,
  defaultRecordSetNumber,
  defaultRecordSetSize,
} from "@costar-search-x/core";
import { Criteria, LocationSearchCriteria } from "./types";

//on paginate -- detect when reached limit of 1000
export const getCriteriaFromPage = (
  pageNumber: number,
  pageSize: number,
  currentCriteria: Criteria<LocationSearchCriteria>
): Criteria<LocationSearchCriteria> | undefined => {
  if (!currentCriteria) {
    return currentCriteria;
  }
  const currentRecordSetNumber =
    currentCriteria.recordSetNumber || defaultRecordSetNumber;
  const recordSetSize = getRecordSetSize(pageSize);

  const recordSetNumber = getNumberOfPages(
    pageNumber,
    recordSetSize / pageSize
  );

  if (
    currentRecordSetNumber !== recordSetNumber ||
    currentCriteria.recordSetSize !== recordSetSize
  ) {
    return {
      ...currentCriteria,
      recordSetNumber,
      recordSetSize,
    };
  }
  return undefined; //if you havent reached the limit 2000
};

//page number within the record set
export const getRelativePageNumber = (
  absolutePageNumber: number,
  pageSize: number,
  currentCriteria: Criteria<LocationSearchCriteria>
) => {
  const currentRecordSetNumber =
    currentCriteria.recordSetNumber || defaultRecordSetNumber;
  const recordSetSize = currentCriteria.recordSetSize || defaultRecordSetSize;

  return (
    absolutePageNumber -
    (currentRecordSetNumber - 1) * (recordSetSize / pageSize)
  );
};

export const getNumberOfItems = (counts: number | undefined) => {
  return counts;
};

export const isCriteriaValid = (criteria: LocationSearchCriteria): boolean => {
  if (criteria) {
    const parsedCriteria = JSON.parse(
      JSON.stringify(criteria)
    ) as LocationSearchCriteria;

    return !!parsedCriteria?.locationCriteria?.company?.companyKey;
  }
  return false;
};
